import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>&copy; 2026 Miyel. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;